import React, {useEffect} from "react";
import useMapProps from "./useMapProps";
import {MapPropsProvider} from "./MapPropsContext";
import MapBase from "./MapBase";
import WidgetContainer from "./widgets/WidgetContainer";
import WidgetTable from "./widgets/WidgetTable";
import {getApiUrl, makeTableSorterFn} from "../../utils";
import WidgetGeocoding from "./widgets/WidgetGeocoding";
import WidgetToolbar from "./widgets/WidgetToolbar";
import WidgetLegend from "./widgets/WidgetLegend";

const INITIAL_VIEW_STATE = {
  zoom: 8,
};

const MapWifiDensity = () => {
  const mapProps = useMapProps({
    INITIAL_VIEW_STATE,
  });

  const {
    updateMapLayerNames,
  } = mapProps;

  useEffect(() => {
    updateMapLayerNames('WIFI_ZONE_SHP', true);
  }, [updateMapLayerNames]);

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase isIgnoreCenterChangeEvent={true} isHideControlOnClustering={true}>
        <WidgetContainer>
          <WidgetGeocoding zoom={16}/>
        </WidgetContainer>
        <WidgetLegend />
      </MapBase>
      <WidgetTable
        fetchUrl={getApiUrl({ type: "type1" })}
        getTitle={(layer) => "무선국 데이터 밀집도"}
        columns={[
          {title: 'SKT',  dataIndex: 'skt', key: 'skt', sorter: makeTableSorterFn('skt')},
          {title: 'KT',   dataIndex: 'kt', key: 'kt', sorter: makeTableSorterFn('kt')},
          {title: 'LGT',  dataIndex: 'lgt', key: 'lgt', sorter: makeTableSorterFn('lgt')},
          {title: '공공',  dataIndex: 'gg', key: 'gg', sorter: makeTableSorterFn('gg')},
          {title: '지자체', dataIndex: 'gl', key: 'gl', sorter: makeTableSorterFn('gl')},
        ]}
      />
      <WidgetToolbar />
    </MapPropsProvider>
  );
};


export default MapWifiDensity;
